module.exports = __webpack_public_path__ + "static/welcome-52b8588777373917c606f2fac648414f.jpg";